module.exports = __webpack_public_path__ + "img/PASTE.2fec3a96.svg";